<template>
  <div class="group-root" :class="{ root }">
    <div class="name" :class="{ root }" @click="toggleOpen">
      <i v-if="!open && hasSubgroups && isInactive" class="fal fa-users-class inactive" :title="title"></i>
      <i v-else-if="!open && hasSubgroups" class="fas fa-users-class" :title="title"></i>
      <i v-else-if="!hasSubgroups && isInactive" class="fal fa-user-friends inactive" :class="{ open }"></i>
      <i v-else class="fas fa-user-friends" :class="{ open, inactive: isInactive }" :title="title"></i>
      <span @click.stop="$emit('select', group)"
            :class="{ selected: isSelected, inactive: isInactive }" :title="titleSelect">{{ group.name }}
      </span>
      <i v-if="isSelected" class="fas fa-dot-circle" style="float: right; line-height: inherit;"></i>
    </div>
    <div class="subgroups" v-if="open && group.subGroups && group.subGroups.length">
      <GroupSelector v-for="item in group.subGroups" :key="item.id" :group="item" @select="$emit('select', $event)" :selectedId="selectedId"/>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Group } from '@/types/Catalogs'
import { GroupStatus } from '@/types/catalogs/Groups'

@Component({
  name: 'GroupSelector'
})
export default class GroupSelector extends Vue {
  @Prop({ required: true })
  group: Group

  @Prop({ required: false, default: false })
  root: boolean

  @Prop({ required: false, default: false })
  opened: boolean

  @Prop({ required: false, default: 0 })
  selectedId: number

  open = false

  get title () {
    return this.open ? 'Ocultar subgrupos' : 'Ver subgrupos'
  }

  get isSelected () {
    return this.selectedId === this.group.id
  }

  get isInactive () {
    return this.group.status === GroupStatus.INACTIVE
  }

  get hasSubgroups () {
    return this.group.subGroups.length > 0
  }

  get titleSelect () {
    return this.isSelected ? 'Clic para deseleccionar' : 'Clic para seleccionar'
  }

  toggleOpen () {
    this.open = !this.open
  }

  created () {
    this.open = this.opened
  }
}
</script>
